import DataMappingTypes from 'store/actionTypes/dataMapping'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  filter: {},
  pagination: {},
  current: {}
}

const DataMapping = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case DataMappingTypes.GET_DATA_MAPPINGS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }

    case DataMappingTypes.UPDATE_FILTER_DATA_MAPPING_SUCCESS:
      return { ...state, filter: payload }

    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default DataMapping
